export default [
  {
    name: 'defaultToolsInHospitalList',
    path: 'toolsInHospitalList',
    component: () => import(/* webpackChunkName: 'defaultToolsInHospitalList' */ '../views/inHospitalDataModule/list/index.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultToolsInHospitalList',
    },
  },
  {
    name: 'defaultToolsInHospitalListSpecial',
    path: 'toolsInHospitalListSpecial',
    component: () => import(
      /* webpackChunkName: 'defaultToolsInHospitalListSpecial' */ '../views/inHospitalDataModule/list/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'defaultToolsInHospitalDetail',
    path: 'toolsInHospitalDetail',
    component: () => import(
      /* webpackChunkName: 'defaultToolsInHospitalDetail'  */
      '../views/inHospitalDataModule/patientDetails/index.vue'),
    meta: {
      tabGroup: 'defaultToolsInHospitalList',
    },
  },
  {
    name: 'defaultToolsInHospitalMessage',
    path: 'toolsInHospitalMessage',
    component: () => import(/* webpackChunkName: 'defaultToolsInHospitalMessage' */ '../views/inHospitalDataModule/list/message.vue'),
  },
  {
    name: 'defaultToolsInHospitalGroup',
    path: 'toolsInHospitalgroup',
    component: () => import(/* webpackChunkName: 'toolsInHospitalgroup' */ '../views/inHospitalDataModule/list/group.vue'),
  },
];
